import { createSlice } from "@reduxjs/toolkit";
import {
  ErrorIcon,
  InfoIcon,
  SuccessIcon,
  WarningIcon,
} from "../../assets/icons";

const initialState = {
  snackBar: {
    snackBarOpen: false,
    snackBarMessage: "",
    color: "",
    borderColor: "",
    Icon: null,
  },
};

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    setSnackBarSuccess: (state, { payload }) => {
      const { snackBarMessage } = payload;

      return {
        ...state,
        snackBar: {
          ...state.snackBar,
          snackBarMessage,
          snackBarOpen: true,
          color: "black",
          borderColor: "#13C163",
          Icon: <SuccessIcon />,
        },
      };
    },
    setSnackBarFailed: (state, { payload }) => {
      const { snackBarMessage } = payload;
      return {
        ...state,
        snackBar: {
          ...state.snackBar,
          snackBarMessage,
          snackBarOpen: true,
          color: "#FF1E00",
          borderColor: "#FF1E00",
          Icon: <ErrorIcon />,
        },
      };
    },
    setSnackBarWarning: (state, { payload }) => {
      const { snackBarMessage } = payload;
      return {
        ...state,
        snackBar: {
          ...state.snackBar,
          snackBarMessage,
          snackBarOpen: true,
          color: "#EB8600",
          borderColor: "#EB8600",
          Icon: <WarningIcon />,
        },
      };
    },
    setSnackBarInfo: (state, { payload }) => {
      const { snackBarMessage } = payload;
      return {
        ...state,
        snackBar: {
          ...state.snackBar,
          snackBarMessage,
          snackBarOpen: true,
          color: "#207DFF",
          borderColor: "#207DFF",
          Icon: <InfoIcon />,
        },
      };
    },

    setClearSnackBar: (state) => ({
      ...state,
      snackBar: {
        ...state.snackBar,
        snackBarMessage: "",
        snackBarOpen: false,
        severity: "",
        color: "",
        borderColor: "",
        Icon: null,
      },
    }),
  },
});

export const {
  setSnackBarSuccess,
  setClearSnackBar,
  setSnackBarFailed,
  setSnackBarWarning,
  setSnackBarInfo,
} = snackbarSlice.actions;

export default snackbarSlice.reducer;
